import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getMillOrderList = createAsyncThunk(
  "get-mill-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("mill/order/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createMillOrder = createAsyncThunk(
  "create-mill-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("mill/order", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdMillOrder = createAsyncThunk(
  "edit-mill-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`mill/order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateMillOrder = createAsyncThunk(
  "update-mill-order",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/mill/order/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateMillOrderStatus = createAsyncThunk(
  "update-mill-order-status",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/mill/order/update-status/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteMillOrder = createAsyncThunk(
  "delete-mill-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/mill/order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const millOrderSlice = createSlice({
  name: "mill-order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMillOrderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMillOrderList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.millOrderList?? [];
        state.perPage = action?.payload?.data?.data?.perPage?? 1;
        state.total = action?.payload?.data?.data?.total?? 0;
      })
      .addCase(getMillOrderList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default millOrderSlice.reducer;
